import type { SettingsTabId } from '../../store/proxy-store';
import type { SettingsTabHeaderConfigEntry } from './settingsTabHeaderConfig';

export const PROXY_SETTINGS_TAB_HEADERS: Record<
  SettingsTabId,
  SettingsTabHeaderConfigEntry
> = {
  general: {
    titleKey: 'proxyGeneralTitle',
    descriptionKey: 'proxyGeneralDescription',
    howToUseKey: 'proxyGeneralHowToUse',
  },
  upstream: {
    titleKey: 'proxyUpstreamTitle',
    descriptionKey: 'proxyUpstreamDescription',
    howToUseKey: 'proxyUpstreamHowToUse',
  },
  headers: {
    titleKey: 'proxyHeadersTitle',
    descriptionKey: 'proxyHeadersDescription',
    howToUseKey: 'proxyHeadersHowToUse',
  },
  security: {
    titleKey: 'proxySecurityTitle',
    descriptionKey: 'proxySecurityDescription',
    howToUseKey: 'proxySecurityHowToUse',
  },
  browser: {
    titleKey: 'proxyBrowserTitle',
    descriptionKey: 'proxyBrowserDescription',
    howToUseKey: 'proxyBrowserHowToUse',
  },
  'client-tls-certificates': {
    translationNamespace: 'settings.clientTls',
    titleKey: 'title',
    descriptionKey: 'subtitle',
    howToUseKey: 'howToUse',
    howToUseNamespace: 'settings.clientTls',
  },
  shortcuts: {
    titleKey: 'proxyShortcutsTitle',
    descriptionKey: 'proxyShortcutsDescription',
    howToUseKey: 'proxyShortcutsHowToUse',
  },
  'mcp-servers': {
    titleKey: 'mcpServers',
    descriptionNamespace: 'settings.mcpServerForm',
    descriptionKey: 'headerSubtitle',
    howToUseKey: 'mcpServersHowToUse',
  },
};
